module.exports = __webpack_public_path__ + "sg.5e652763.svg";